document.addEventListener('DOMContentLoaded', function() {

  // Function to safely play a video
  function safePlay(video) {
    if (!video) return;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  }

  // Function to safely pause video
  function safePause(video) {
    if (!video) return;
    try { video.pause(); } catch (e) {}
  }

  // Initialize IntersectionObserver to detect when videos come into view
  function initVideoObserver() {
    const videos = document.querySelectorAll('.product-gallery video'); // adjust selector if needed
    if (!videos.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const vid = entry.target;
        if (entry.isIntersecting) {
          safePlay(vid);
        } else {
          safePause(vid);
        }
      });
    }, {
      threshold: 0.5 // video must be at least 50% visible
    });

    videos.forEach(v => {
      observer.observe(v);

      // Ensure attributes exist immediately
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('loop', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('autoplay', '');
      v.preload = 'metadata';
    });
  }

  // Run on DOM ready
  initVideoObserver();

  // Observe gallery DOM changes (for Prestige sliders)
  const gallery = document.querySelector('.product-gallery');
  if (gallery) {
    const mo = new MutationObserver(() => {
      setTimeout(initVideoObserver, 200); // re-apply observer to new video elements
    });
    mo.observe(gallery, { childList: true, subtree: true });
  }
});
